import $checkPrivilege from './methods/checkPrivilege'
import $truncateText from '@/utils/truncateText'
import { formatDate, transformDate } from '@/utils/date'

export default {
  $transformDate: transformDate,
  $checkPrivilege,
  $truncateText,
  $formatDate: formatDate
}
